import type { ReactNode } from "react";

interface DetailRowProps {
  label: string;
  code?: string;
  hint?: string;
  /** Non-code content (Tag lists, plain text) rendered after the label. */
  children?: ReactNode;
}

/** One read-only "label: `code` (— hint)" line of a field detail panel. */
export function DetailRow({ label, code, hint, children }: DetailRowProps) {
  return (
    <div>
      <span className="text-noa-muted">{label}:</span> {code !== undefined && <code>{code}</code>}
      {children}
      {hint && <> — {hint}</>}
    </div>
  );
}
